import {
    get,
    post,
    put
} from "./http";
import qs from 'qs'



//首页---顶部信息
export const topInfo = (params) => {
    let url = "/jysk/brain/industrial/index/top/info";
    return get(url, params);
}

// 首页---产业介绍
export const industryIntroduce = (params) => {
    let url = "/jysk/brain/industrial/index/industry/introduce";
    return get(url, params);
}
// 首页---产业发展规模
export const industryDevelopment = (params) => {
    let url = "/jysk/brain/industrial/index/industry/development";
    return get(url, params);
}

//首页---新闻列表
export const homeArticleList = (params) => {
    let url = "/jysk/brain/industrial/index/article/list";
    return get(url, params);
}

//首页---产业大事记
export const industryChronicle = (params) => {
    let url = "/jysk/brain/industrial/index/industry/chronicle";
    return get(url, params);
}

//首页---产业图谱数据
export const diagramList = (params) => {
    let url = "/jysk/brain/industrial/diagram/list";
    return get(url, params);
}


//产业图谱---右侧列表数据数据
export const diagramRightList = (params) => {
    let url = "/jysk/brain/industrial/diagram/right/list";
    return get(url, params);
}